// Grayhaven signature DNA helix — thin-lined, slightly dimensional.
// Slate strands, champagne rungs, restrained deep-wine node accents.
const W = 120;
const H = 400;
const CX = W / 2;
const AMP = 42;
const CYCLES = 3;
const STEPS = 72;
const RUNG_EVERY = 6;

function strandPath(phase) {
    let d = "";
    for (let i = 0; i <= STEPS; i++) {
        const t = i / STEPS;
        const y = t * H;
        const x = CX + AMP * Math.sin(t * CYCLES * 2 * Math.PI + phase);
        d += `${i === 0 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)}`;
    }
    return d;
}

export default function DnaHelix({ className = "", horizontal = false }) {
    const rungs = [];
    for (let i = 0; i <= STEPS; i += RUNG_EVERY) {
        const t = i / STEPS;
        const y = t * H;
        const angle = t * CYCLES * 2 * Math.PI;
        const x1 = CX + AMP * Math.sin(angle);
        const x2 = CX + AMP * Math.sin(angle + Math.PI);
        // depth: front strand crossing = stronger rung
        const depth = Math.abs(Math.cos(angle));
        rungs.push({ y, x1, x2, opacity: 0.25 + depth * 0.55, wine: (i / RUNG_EVERY) % 5 === 2 });
    }

    return (
        <svg
            viewBox={`0 0 ${W} ${H}`}
            fill="none"
            className={className}
            aria-hidden="true"
            style={horizontal ? { transform: "rotate(90deg)" } : undefined}
        >
            {/* rungs */}
            {rungs.map((r, i) => (
                <line
                    key={i}
                    x1={r.x1}
                    y1={r.y}
                    x2={r.x2}
                    y2={r.y}
                    stroke={r.wine ? "#7A2230" : "#C9A97E"}
                    strokeWidth="1"
                    opacity={r.opacity}
                />
            ))}
            {/* strands */}
            <path d={strandPath(0)} stroke="currentColor" strokeWidth="1.4" />
            <path d={strandPath(Math.PI)} stroke="#C9A97E" strokeWidth="1.4" />
            {/* nodes */}
            {rungs.map((r, i) => (
                <g key={`n${i}`}>
                    <circle cx={r.x1} cy={r.y} r="2" fill={r.wine ? "#7A2230" : "currentColor"} />
                    <circle cx={r.x2} cy={r.y} r="2" fill="#C9A97E" />
                </g>
            ))}
        </svg>
    );
}
